import { useEffect, useState } from "react";
export var useDetailFormState = function () {
    var _a = useState({}), messages = _a[0], setMessages = _a[1];
    var _b = useState(null), saveState = _b[0], setSaveState = _b[1];
    useEffect(function () {
        if (saveState === "saved") {
            setTimeout(function () {
                reset();
            }, 2000);
        }
    }, [saveState]);
    useEffect(function () {
        if (messages.success) {
            setSaveState("saved");
        }
        else if (messages.failed) {
            setSaveState("failed");
        }
        else if (messages.errors) {
            setSaveState("errors");
        }
    }, [messages, setSaveState]);
    var reset = function () {
        setSaveState(null);
        setMessages({});
    };
    return { messages: messages, saveState: saveState, setMessages: setMessages, setSaveState: setSaveState, reset: reset };
};
